import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import DailyDetails from "./components/daily-details"
import BetaContributors from "modules/analyze-composite-beta-contributors"
import "./style.scss"

function AnalyzeBetaDetails({
  account,
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  base,
  baseSignature,
  segment,
  classifications,
  missingDataFiles,
  expand,
  selectedDate,
  details,
  viewType,
  factorCategoryId,
  factorCategoryName,
  sortOrder,
  setSortOrder,
  setGroupSortOrder,
  setGrouping,
  drift,
  openSecurityProfile,
  currentGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  contentSetId,
  showContributorCategory,
  hideContributorCategory,
  selectedContributorCategory,
  selectedContributorValue,
  groupOrder,
  showNotHeld,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-beta-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    {!selectedContributorCategory
      ? <DailyDetails {...{
          drift,
          viewType,
          displayTypeName: factorCategoryName,
          data: details,
          factorTable: factorCategoryId !== "total" && factorCategoryId !== "factors",
          show: showContributorCategory,
          groupSort: (order) => setGroupSortOrder({ ...groupOrder, order }),
          groupOrder,
        }}
      />
      : <BetaContributors {...{
          account,
          modelId,
          positionSetId,
          positionSetType,
          positionSetName,
          viewType,
          base,
          baseSignature,
          segment,
          classifications,
          missingDataFiles,
          expand,
          openSecurityProfile,
          showGroup,
          hideGroup,
          selectedGroup,
          groupOrder,
          setGrouping,
          showContributorCategory,
          hideContributorCategory,
          sort: handleSort,
          sortOrder,
          selectedContributorCategory,
          selectedContributorValue,
          selectedDate,
          factorCategoryName,
          currentGrouping,
          selectedOption,
          contentSetId,
          showNotHeld,
          details,
        }}
      />}
  </div>
}

AnalyzeBetaDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  base: PropTypes.object,
  baseSignature: PropTypes.string,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  expand: PropTypes.bool,
  selectedDate: PropTypes.string,
  beta: PropTypes.array.isRequired,
  missingDataFiles: PropTypes.object.isRequired,
  allCategoryItems: PropTypes.array.isRequired,
  details: PropTypes.array,
  viewType: PropTypes.string,
  factorCategoryId: PropTypes.string,
  factorCategoryName: PropTypes.string.isRequired,
  sort: PropTypes.func,
  sortOrder: PropTypes.object,
  setSortOrder: PropTypes.func.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number,
  drift: PropTypes.object,
  openSecurityProfile: PropTypes.func,
  currentGrouping: PropTypes.object,
  contentSetId: PropTypes.string,
  filtersVisible: PropTypes.bool.isRequired,
  showNotHeld: PropTypes.bool.isRequired,
}

export default AnalyzeBetaDetails
